import { Button } from "@9amhealth/shared";
import styled from "@emotion/styled";
import Translate from "components/Translate/Translate";
import { PopupDialog } from "molecule/popupDialog/PopupDialog";
import { PopupDialogTrigger } from "molecule/popupDialog/PopupDialogTrigger";
import type { FC } from "react";
import { APP_CONTENT_WIDTH_WITHOUT_PADDING } from "src/constants/layout";

const Container = styled.div`
  max-width: ${APP_CONTENT_WIDTH_WITHOUT_PADDING}px;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100%;
  padding: 2rem 1.6rem;
`;

const ProviderImage = styled.img`
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  object-fit: cover;
  background-color: var(--color-charcoal-10);
`;

const SkipLabsOptionStep: FC<{
  userCanSkip: boolean;
  onChooseLabs: () => void;
  onSkipLabs: () => void;
}> = (props) => {
  return (
    <Container>
      <ProviderImage
        src="https://cdn.sanity.io/images/g38rxyoc/production/2db9cd6157b1ab1a4f988ec15ce5f0e6a0f29b49-1200x900.png?width=120"
        aria-hidden
      />
      <nine-spacer s="md" />

      <h4>
        <Translate msg="skipLabsOption.title" />
      </h4>
      <nine-spacer s="md" />

      <p>
        <Translate msg="skipLabsOption.description" />
      </p>
      <nine-spacer s="lg" />

      <Button onPress={props.onChooseLabs} theme="sunrise" grow>
        <Translate msg="skipLabsOption.cta" />
      </Button>

      <nine-spacer s="sm" />

      <PopupDialogTrigger>
        {props.userCanSkip && (
          <Button
            theme="danger"
            outline
            hideArrow
            grow
            style={
              {
                "--inner-background": "var(--color-cream)",
                "--border-size": "1px"
              } as React.CSSProperties
            }
          >
            <Translate msg="skipInitialLabs_labsRequired" />
          </Button>
        )}
        <PopupDialog
          title={<Translate msg="skipLabsOption.dialog.title" />}
          actions={(popup) => (
            <>
              <Button
                theme="simple"
                hideArrow
                onPress={() => {
                  props.onChooseLabs();
                  popup.close();
                }}
              >
                <Translate msg="skipLabsOption.dialog.keepLabs" />
              </Button>
              <Button
                theme="charcoal"
                onPress={() => {
                  props.onSkipLabs();
                  popup.close();
                }}
              >
                <Translate msg="skipLabsOption.dialog.skipForNow" />
              </Button>
            </>
          )}
        >
          <Translate msg="skipLabsOption.dialog.description" />
        </PopupDialog>
      </PopupDialogTrigger>
    </Container>
  );
};

export default SkipLabsOptionStep;
